// src/components/YourModule/PurchaseOrders.js

import React from "react";
import AllPurchaseOrders from "./PurchaseOrderModule/AllPurchaseOrders";

const PurchaseOrders = () => {
  return (
    <div>
      <AllPurchaseOrders />
    </div>
  );
};

export default PurchaseOrders;
